export default "__VITE_ASSET__BXEQxYJF__"